(function () {
    'use strict';

    angular.module('AngularAdmin')

        .factory('MembershipSvc', ['$http', '$q', 'ModalSvc', function ($http, $q, ModalSvc) {


            var membershipSvc = {
                list: function (plant_id) {
                    var url = String.format('/plant/{0}/memberships/', plant_id);

                    return $http.get(url, {});
                },
                list_users: function (plant_id) {
                    var url = String.format('/plant/{0}/users/', plant_id);

                    return $http.get(url, {});
                },
                list_customers: function (plant_id) {
                    var url = `/plant/${plant_id}/customer_memberships/`;
                    return $http.get(url, {});
                },
                list_roles: function (plant_id) {
                    var url = String.format('/plant/{0}/roles/', plant_id);

                    return $http.get(url, {});
                },
                listToIdMap: function (list) {
                    var map = {};
                    for (var i = list.length - 1; i >= 0; i--) {
                        map[list[i].id] = list[i];
                    }
                    return map;
                },
                count_by_role: function(plant_id, role_name){
                    var url = `/plant/${plant_id}/customer_memberships_count/?role=${role_name}`;
                    return $http.get(url, {});
                },
                create: function (membership, plant_id) {
                    var url = String.format('/plant/{0}/membership/new/', plant_id);
                    return $http({
                        method: 'POST',
                        url: url,
                        data: membership
                    });
                },
                update: function (membership, plant_id) {
                    var url = String.format('/plant/{0}/membership/{1}/', plant_id, membership.id);
                    return $http({
                        method: 'PUT',
                        url: url,
                        data: membership
                    })
                },
                delete: function (membership, plant_id, confirm=true) {
                    var deferred = $q.defer();

                    if(confirm){
                        var confirmation = ModalSvc.confirmationDialog.open({
                            title: `Delete membership of ${membership.user_name}`,
                            message: `Are you sure you want to delete the membership of ${membership.user_name}`
                        });

                        confirmation.result.then(function(){
                            doDelete();
                        });
                    }
                    else {
                        doDelete();
                    }

                    function doDelete(){
                        var url = `/plant/${plant_id}/membership/${membership.id}/delete/`;
                        return $http({
                            method: 'DELETE',
                            url: url
                        }).then(function(result){
                            deferred.resolve(result);
                        }, function(result){
                            deferred.reject(result);
                        });
                    }

                    return deferred.promise;
                }
            };

            return membershipSvc;
        }]);

})();